import FormField from '../FormField/FormField';
import './OrgSignupForm.css';
import { categoriesFieldsOrg } from '../../constants/categoriesField';
import SubmitButton from '../SubmitButton/SubmitButton';
import InputAddImage from '../InputAddImage/InputAddImage';
import { useRef } from 'react';
import { removeImage } from '../../api/orgsApi';
const OrgSignupForm = ({
  activeForm,
  formData,
  handleChange,
  handleSubmit,
  toggleForm,
  handleFillByINN,
  handleFillByBIK,
  requiredFields,
  handleBlur,
  isLoading,
  handleFocus,
}) => {
  const fileInputRef = useRef(null); // Ссылка на input для выбора файла
  const modifierClassesFormField = {
    label: 'auth-forms__title-input_org-reg',
    input: 'auth-forms__input_org-reg',
    inputWrapper: 'auth-forms__wrapper-input_org-reg',
    field: 'form-field_org-reg',
  };
  const handleFormClose = () => {
    if (formData.image) {
      removeImage(formData.image) // Удаляем загруженное изображение
        .then(() => console.log('Изображение удалено'))
        .catch((err) => console.log('Ошибка удаления', err));
    }

    fileInputRef.current.value = ''; // Очищаем input
    handleChange({ target: { name: 'image', value: '' } }); // Очищаем state
    toggleForm(null);
  };

  return (
    <>
      <div
        onClick={handleFormClose}
        className={`overlay ${activeForm === 'registerOrg' ? 'show' : 'hide'}`}
      ></div>
      <div
        className={`auth-forms__form ${activeForm === 'registerOrg' ? 'show' : ''
          } auth-forms__form_org-signup-form`}
      >
        <h2 className='auth-forms__title'>Добавить организацию</h2>
        <form
          onSubmit={handleSubmit}
          className='auth-forms__form-container'
          autoComplete='off'
        >
          <div className='auth-forms__form-wrapper'>
            {categoriesFieldsOrg.map(
              ({ label, type, name, placeholder, maxLength }) =>
                name === 'image' ? (
                  <div key={name} className='auth-forms__image-upload'>
                    <label className='auth-forms__title-input_org-reg'>
                      Изображение
                    </label>
                    <InputAddImage
                      imageValue={formData.image ? formData.image : null}
                      fileInputRef={fileInputRef}
                      handleChange={handleChange}
                    />
                    {formData.errors?.image && (
                      <div className='auth-forms__error'>
                        {formData.errors.image}
                      </div>
                    )}
                  </div>
                ) : (
                  <FormField
                    children={
                      name === 'inn' ? (
                        <SubmitButton
                          text='Заполнить по ИНН'
                          disabled={
                            formData.errors['inn'] ||
                            formData['inn'] === '' ||
                            formData['inn'] === undefined
                          }
                          id='inn'
                          isLoading={isLoading === 'inn'}
                          type='button'
                          className='auth-forms__button_input'
                          onClick={(e) => handleFillByINN(e, formData['inn'])}
                          onDownCl
                        />
                      ) : name === 'bik' ? (
                        <SubmitButton
                          onClick={(e) => handleFillByBIK(e, formData['bik'])}
                          text='Заполнить по БИК'
                          disabled={
                            formData.errors['bik'] ||
                            formData['bik'] === '' ||
                            formData['bik'] === undefined
                          }
                          id='bik'
                          isLoading={isLoading === 'bik'}
                          type='button'
                          className='auth-forms__button_input'
                        />
                      ) : (
                        <></>
                      )
                    }
                    required={requiredFields.includes(name)}
                    key={name}
                    label={label}
                    type={type}
                    name={name}
                    value={formData[name] || ''}
                    onChange={handleChange}
                    placeholder={placeholder}
                    error={formData.errors?.[name]}
                    modifierClassesFormField={modifierClassesFormField}
                    onBlur={handleBlur}
                    onFocus={handleFocus}
                    maxLength={maxLength}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' && name === 'inn') {
                        handleFillByINN(e, formData['inn']);
                      } else if (e.key === 'Enter' && name === 'bik') {
                        handleFillByBIK(e, formData['bik']);
                      }
                    }}
                  />
                )
            )}
          </div>
          <div className='auth-forms__form_org-buttons'>
            <SubmitButton
              text='Зарегистрировать'
              type='submit'
              className=''
              isLoading={isLoading === 'registerOrg'}
              id='registerOrg'
            />
          </div>
        </form>
      </div>
    </>
  );
};

export default OrgSignupForm;
